
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.519 2.225a.32.32 0 01.4-.21l1.112.346a.32.32 0 01.188.156l.508.965.124-.124 1.656.148c.544.593 1.661 1.824 1.78 2.002.119.178.05.717 0 .964h-1.99l2 3.807a.32.32 0 11-.565.297L17.7 6.706l-.032.014c-.322.37-1.088 1.24-1.582 1.755-.618.642-4.87 3.262-6.18 3.188-1.048-.06-1.771-.634-2.002-.914l-.051-.15H4.195a.32.32 0 01-.187-.58L6.94 7.91l-.026-.077v-.346c-1.705-.94-5.141-2.843-5.24-2.942-.124-.123-.223-.593.123-.84 2.867-.319 3.504.402 3.961.918.182.205.335.378.588.441.625.157.847.13 1.31.075.196-.024.435-.053.766-.075.638-.042.658-.06.936-.31.208-.186.558-.5 1.412-1.05 1.602-1.027 3.337-.428 4.005 0h1.31l.03-.01-.4-.762-.986-.306a.32.32 0 01-.21-.4zM7.635 9.959l-.48-1.418-1.97 1.418h2.45zm10.007-5.91c.165.487.613 1.524 1.088 1.78.474.258.972.256 1.161.223v-.445L18.334 4.05h-.692zM2.138 10.314a1.92 1.92 0 001.917 1.917 1.92 1.92 0 001.848-1.406h1.164a3.055 3.055 0 11-.871-2.691l-.944.683a1.909 1.909 0 00-1.197-.42 1.92 1.92 0 00-1.917 1.917zm17.806-1.917a1.92 1.92 0 011.917 1.917 1.92 1.92 0 01-1.917 1.917 1.92 1.92 0 01-1.917-1.917c0-.548.231-1.042.601-1.392l-.545-1.03a3.055 3.055 0 10.904-.48l.545 1.03c.133-.03.27-.045.412-.045zM5.852 9.644c.019.052.036.104.05.158h1.165a3.032 3.032 0 00-.271-.84l-.944.682zm8.827 1.213a.132.132 0 01-.092.027l-1.51-.143 2.935-1.78-.14.909a.162.162 0 01-.06.103l-1.133.884z","fill":"currentColor"}})])
          )
        }
      }
    